/** True when running inside the Discord Activity iframe (`*.discordsays.com`). */
export function isEmbedded(hostname: string = location.hostname): boolean {
  return hostname.endsWith('discordsays.com');
}

/**
 * Colyseus endpoint. Inside Discord every request must go through the `/.proxy` URL mapping;
 * on the web we talk to the origin directly. The server strips `/.proxy` (DESIGN-server §6.1).
 */
export function colyseusEndpoint(origin: string = location.origin, hostname: string = location.hostname): string {
  return `${origin}${isEmbedded(hostname) ? '/.proxy' : ''}`;
}

/** Same rule for plain HTTP calls (`/api/*`). */
export function apiUrl(path: string, origin: string = location.origin, hostname: string = location.hostname): string {
  return `${colyseusEndpoint(origin, hostname)}${path}`;
}
